export class ListToolbarItemsRemoveAction {
  constructor(public ids: string[]) {}
}
